import React from 'react';
import { CommunityEvents } from '../components/CommunityEvents';

export function EventsPage() {
  return (
    <div className="max-w-4xl mx-auto py-8">
      <CommunityEvents />
    </div>
  );
}